import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { StepLabel, Stepper, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledTitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500
}))

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 400
}))

export const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
  marginTop: "-2px",
  fontSize: "2rem",
  cursor: "pointer",
  fontWeight: 500,
  padding: 0,
  "& .MuiStepLabel-label": {
    fontSize: "1rem",
    fontWeight: 500
  }
}))

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  background: "transparent",
  marginBottom: 13,
  "& .MuiStep-vertical": {
    zIndex: 1
  },
  "& .MuiStepConnector-vertical": {
    borderLeftWidth: "4px",
    marginLeft: "11px",
    marginTop: "-2px",
    "& .MuiStepConnector-line": {
      minHeight: "34px"
    },
    "&.Mui-active .MuiStepConnector-line": {
      borderColor: theme.palette.primary["main"]
    },
    "&.Mui-completed .MuiStepConnector-line": {
      borderColor: theme.palette.success["main"]
    }
  }
}))

const sharedIconStyle = {
  borderRadius: 25,
  height: 14,
  width: 14,
  padding: 6
}
export const StyledStepIcon = styled(FontAwesomeIcon)(sharedIconStyle)
